import axios from 'axios'
import { apiCheckSip } from '../config/env'
let headers = {
    'content-type': 'application/json'
}
const axiosCheckSip = axios.create({
    baseURL: apiCheckSip,
    headers: headers
})
axiosCheckSip.interceptors.request.use(
    (config) => {
        // const token = localStorage.getItem('accessToken');
        // if(token) {
        //     config.headers.Authorization = `Bearer ${token}`
        // }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosCheckSip.interceptors.response.use(
    (response) => {
        return response;        
    }, 
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosCheckSip